import React from 'react';
import { useSelector } from 'react-redux';

import { IconGoodCondition } from 'svgIcons/MotionPortalIcons';
import { ScrollableList } from 'sharedComponents/ScrollableList';
import { translate } from 'helpers/translateHelper';

const DriveEventsSummaryTable = () => {
    const driveEventsSummary = useSelector(({ assetOverviewV2 }) => assetOverviewV2?.driveEventsSummary);

    const renderHeader = () => {
        return <div className='asset-overview-params-header-v2'>
            <div className='header-item'>
                {translate('ABB.Powertrain.Frontend.assetOVerviewEventCategoryLabel')}
            </div>
            <div className='header-item'>
                {translate('ABB.Powertrain.Frontend.assetOVerviewFaultLabel')}
            </div>
            <div className='header-item'>
                {translate('ABB.Powertrain.Frontend.assetOVerviewWarningLabel')}
            </div>
        </div>;
    };

    const renderNoEventsSummary = () => {
        return (
            <div className='render-no__drive-events'>
                <IconGoodCondition />
                <p>{translate('ABB.Powertrain.Frontend.assetOverviewNoDriveEvents')}</p>
            </div>
        );
    };

    const renderConditionItem = (key, value) => {
        return (
            <div key={key} className='asset-overview-params__list drive-events-params-list'
            >
                <div className='asset-overview-params-value'>
                    {translate(`ABB.Powertrain.Frontend.${key}EventsLabel`)}
                </div>
                <div className='asset-overview-params-value'>{value.fault}</div>
                <div className='asset-overview-params-value'>
                    {value.warning}
                </div>
            </div>
        );
    };

    if (!Object.keys(driveEventsSummary)?.length) {
        return renderNoEventsSummary();
    }

    return (
        <>
            {renderHeader()}
            <ScrollableList>
                {Object.entries(driveEventsSummary).map(([key, value]) =>
                    renderConditionItem(key, value)
                )}
            </ScrollableList>
        </>
    );
};

DriveEventsSummaryTable.propTypes = {

};

export default DriveEventsSummaryTable;
